<template>
    <div>

        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                消息通知
            </blockquote>
        </div>

        <div class="layui-card-body">
            <el-tabs type="border-card" style="margin-top: 10px;">
                <el-tab-pane label="个人消息">
                    <el-table :data="tableData" style="width: 100%">
                        <!-- 序号 -->
                        <el-table-column align="center" label="序号" width="200" type="index">
                        </el-table-column>

                        <el-table-column align="center" :show-overflow-tooltip="true" label="消息标题" width="290"
                            prop="noticeTitle">
                        </el-table-column>

                        <el-table-column align="center" label="状态" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.readState == 1" style="color: red;">未读</span>
                                <span v-if="scope.row.readState == 2" style="color: green;">已读</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="250" align="center">
                            <template slot-scope="scope">

                                <el-button size="mini" type="primary" @click="Details(scope.row)">查看</el-button>

                                <el-button size="mini" type="danger" @click="Cancel(scope.row)">删除</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="系统消息">
                    <el-table :data="tableDataHistory" style="width: 100%">
                        <!-- 序号 -->
                        <el-table-column align="center" label="序号" width="200" type="index">
                        </el-table-column>

                        <el-table-column align="center" :show-overflow-tooltip="true" label="消息标题" width="290"
                            prop="noticeTitle">
                        </el-table-column>

                        <el-table-column align="center" label="状态" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.readState == 1" style="color: red;">未读</span>
                                <span v-if="scope.row.readState == 2" style="color: green;">已读</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="250" align="center">
                            <template slot-scope="scope">

                                <el-button size="mini" type="primary" @click="Details(scope.row)">查看</el-button>

                                <el-button size="mini" type="danger" @click="Cancel(scope.row)">删除</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;">
            </el-pagination>

            <el-dialog title="消息详情" :visible.sync="dialogTableVisible2" :center="true" width="70%">

                <div class="layui-card">
                    <div class="noticeTitle">

                        <h2><i class="layui-icon1 layui-icon-speaker"></i>主题：assassin</h2>
                        <h4>发件人：manager</h4>
                        <h4>发送时间：2021-04-25 16:23:20</h4>
                    </div>

                    <div class="layui-card-body" style="min-height: 360px;position: relative;padding: 15px 40px;">
                        <div id="noticeDesc" class="noticeDesc" v-html='desc'></div>

                        <ul class="attachments">
                            <li v-for="(item,index) in downloadList">
                                <a :href="item.downSrc" :download="item.originalName" style="width: auto;">
                                    <i class="layui-icon layui-icon-download-circle"></i>
                                    {{item.originalName}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </el-dialog>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                downloadList: [],
                dialogTableVisible2: false,
                total: 0,   //一共多少条
                pagesize: 10,  //一页几条
                currentPage: 1,//当前页
                tableData: [],
                orderId: 0,
                firmlyBelieveCost: 0,
                declareUserId: 0, //当前点击数据申报表id
                tableDataHistory: [],
                noticeTitle: '',
                sendUserName: '',
                sendTime: '',
                desc: ''
            }
        },
        created() {
            this.loadData(this.currentPage, this.pagesize);
            this.historyLoadData(this.currentPage, this.pagesize);
        },
        mounted() {

        },
        methods: {
            //删除
            Cancel(row) {
                this.$confirm('确认删除?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let parames = new URLSearchParams();
                    parames.append('userId', this.$storage.get('declareUser').id);
                    parames.append('noticeId', row.noticeId);
                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/deleteUserNoticeByMap', parames).then(resp => {
                        if (resp.data.code === 1) {
                            this.$message({
                                message: '恭喜你，删除成功！！',
                                type: 'success'
                            });
                            this.loadData(this.currentPage, this.pagesize);
                            this.historyLoadData(this.currentPage, this.pagesize);
                        }
                    }).catch(err => {
                    })
                }).catch(() => {
                });
            },
            //数字前置补零
            digit(num, length, end) {
                var str = '';
                num = String(num);
                length = length || 2;
                for (var i = num.length; i < length; i++) {
                    str += '0';
                }
                return num < Math.pow(10, length) ? str + (num | 0) : num;
            },
            //时间格式转换
            toDateString(d, format) {
                var date = new Date(d || new Date()), ymd = [
                    this.digit(date.getFullYear(), 4)
                    , this.digit(date.getMonth() + 1)
                    , this.digit(date.getDate())
                ]
                    , hms = [
                        this.digit(date.getHours())
                        , this.digit(date.getMinutes())
                        , this.digit(date.getSeconds())
                    ];

                format = format || 'yyyy-MM-dd HH:mm:ss';

                return format.replace(/yyyy/g, ymd[0])
                    .replace(/MM/g, ymd[1])
                    .replace(/dd/g, ymd[2])
                    .replace(/HH/g, hms[0])
                    .replace(/mm/g, hms[1])
                    .replace(/ss/g, hms[2]);
            },
            //查看
            Details(row) {
                //先更新 消息阅读状态
                let parames = new URLSearchParams();
                parames.append('id', row.id);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/updateUserNoticeState', parames).then(resp => {
                    let parames = new URLSearchParams();
                    parames.append('id', row.id);
                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/getUserNoticeInfoById', parames).then(resp => {

                        if (resp.data.code === 1) {
                            this.dialogTableVisible2 = true;
                            this.noticeTitle = resp.data.data.noticeTitle;
                            this.sendUserName = resp.data.data.sendUserName;
                            this.sendTime = this.toDateString(resp.data.data.sendTime);

                            this.desc = resp.data.data.noticeDesc;

                            let attachments = resp.data.data.attachments;

                            if (attachments != null && attachments.length > 0) {
                                let ArrayList = [];
                                for (var i = 0; i < attachments.length; i++) {

                                    let attachmentsVo = {
                                        downSrc: '',
                                        originalName: ''
                                    }

                                    attachmentsVo.downSrc = this.serverUrl + this.prefiexUrl + attachments[i].downSrc;
                                    attachmentsVo.originalName = attachments[i].originalName;

                                    ArrayList.push(attachmentsVo);
                                }
                                this.downloadList = ArrayList;
                            }
                        }
                    }).catch(err => {
                    })
                }).catch(err => {
                })

            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //个人消息
            loadData(page, limit) {
                let parames = new URLSearchParams();
                parames.append('noticeType', 2);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserNoticeData', parames).then(resp => {
                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//id
                                noticeTitle: '',//通知标题
                                readState: 0,//已读/未读 默认 1：未读  2已读
                                sendTime: '',//发送时间
                                noticeId: 0
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.noticeTitle = element.noticeTitle;
                            UserDeclareOccupationData.readState = element.readState;
                            UserDeclareOccupationData.noticeId = element.noticeId;
                            UserDeclareOccupationData.sendTime = element.sendTime.substring(0, 10); //申报时间

                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableData = ArrayList;
                    }
                }).catch(err => {
                })
            },
            historyLoadData(page, limit) {
                let parames = new URLSearchParams();
                parames.append('noticeType', 3);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserNoticeData', parames).then(resp => {
                    this.total = resp.data.count;
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//id
                                noticeTitle: '',//通知标题
                                readState: 0,//已读/未读 默认 1：未读  2已读
                                sendTime: '',//发送时间
                                noticeId: 0
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.noticeTitle = element.noticeTitle;
                            UserDeclareOccupationData.noticeId = element.noticeId;
                            UserDeclareOccupationData.readState = element.readState;
                            UserDeclareOccupationData.sendTime = element.sendTime.substring(0, 10); //申报时间

                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableDataHistory = ArrayList;
                    }
                }).catch(err => {
                })
            }
        }
    }
</script>

<style scoped>
    .layui-icon-download-circle:before {
        content: "\e601";
    }

    .attachments li i {
        color: blue;
        margin-right: 5px;
        font-size: 15px;
    }

    .layui-icon-speaker:before {
        content: "\e645";
    }

    .layui-icon-speaker {
        font-size: 24px;
        color: red;
    }

    .layui-icon1 {
        font-family: layui-icon !important;
        font-size: 24px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .attachments {
        position: absolute;
        bottom: 20px;
        width: 35%;
        height: auto;
    }

    .noticeDesc {
        margin-bottom: 25px;
    }

    .noticeTitle h4 {
        height: 25px;
        line-height: 25px;
        text-indent: 2em;
        font-size: 13px;
    }

    .noticeTitle h2 {
        margin-bottom: 10px;
        color: #0058ac;
    }

    .noticeTitle {
        margin-top: 20px;
        padding: 0 15px;
        height: auto;
        border-bottom: 1px solid #FFB800;
    }

    .el-table__empty-block {
        min-height: 60px;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .el-dialog {
        position: relative;
        margin: 0 auto 50px;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 80%;
        height: 650px;
        overflow: scroll;
        margin-top: 5vh !important;
    }

    .el-dialog--center .el-dialog__body {
        text-align: initial;
        /* padding: 25px 25px 30px; */
    }

    .el-dialog__body {
        padding: 0 !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }


    #toBuy {
        width: 140px;
        line-height: 38px;
        color: #fff;
        font-size: 16px;
        border-radius: 2px;
        background: #5FB878;
        border: none;
        cursor: pointer;
    }

    .zhifu {
        float: right;
        margin-top: 22px;
        margin-right: 23px;
    }

    .allPrice {
        float: left;
        font-size: 18px;
        color: red;
        margin-top: 27px;
        margin-left: 40px;
    }

    .order_bottom {
        width: 100%;
        height: 79px;
        background-color: white;
        position: absolute;
        bottom: 0px;
        left: 0;
        box-shadow: 0px 2px 6px #ccc;
    }

    .open_right {
        width: 500px;
        margin-top: 31px;
        float: left;
    }

    #ddBox {
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 80px;
        height: 226px;
        overflow-y: auto;
    }

    .open_left {
        float: left;
        margin-top: 19px;
        width: 115px;
        line-height: 60px;
        text-align: right;
        font-size: 14px;
        color: #000000;
        padding-right: 28px;
        box-sizing: border-box;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    select {
        display: none;
    }

    .layui-edge {
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: dashed;
        border-color: transparent;
    }

    .layui-form-select .layui-edge {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        cursor: pointer;
        border-width: 6px;
        border-top-color: #c2c2c2;
        border-top-style: solid;
        transition: all .3s;
        -webkit-transition: all .3s;
    }

    .layui-form-select dl dd,
    .layui-form-select dl dt {
        padding: 0 10px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .layui-form-select dl dd {
        cursor: pointer;
    }

    .layui-form-select dl dd.layui-this {
        background-color: #5FB878;
        color: #fff;
    }

    .layui-form-select dl dd.layui-select-tips {
        padding-left: 10px !important;
        color: #999;
    }

    dl {
        display: none;
        position: absolute;
        left: 0;
        top: 42px;
        padding: 5px 0;
        z-index: 899;
        min-width: 100%;
        border: 1px solid #d2d2d2;
        max-height: 300px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        box-sizing: border-box;
    }

    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 10px;
        height: 38px;
        line-height: 1.3;
        line-height: 38px\9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
    }

    .layui-form-label,
    .layui-form-mid,
    .layui-form-select,
    .layui-input-block,
    .layui-input-inline,
    .layui-textarea {
        position: relative;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-normal {
        background-color: #1E9FFF;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-anim.layui-icon {
        display: inline-block;
    }

    .layui-form-radio>i {
        margin-right: 8px;
        font-size: 22px;
        color: #c2c2c2;
    }

    .layui-form-radio {
        display: inline-block;
        vertical-align: middle;
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .layui-input-block {
        margin-left: 110px;
        min-height: 36px;
    }

    .ux-input_base {
        padding: .16rem .32rem;
        font-size: 14px;
        border: 1px solid #ddd;
        color: #555;
        background: #fff;
        border-radius: 2px;
        vertical-align: middle;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .layui-show {
        display: block !important;
    }

    .layui-upload-drag .layui-icon {
        font-size: 50px;
        color: #009688;
    }

    .layui-upload-file {
        display: none !important;
        opacity: .01;
        filter: Alpha(opacity=1);
    }

    .layui-upload-drag {
        position: relative;
        padding: 30px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    .layui-upload-drag {
        border: 1px solid #5fb878;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .input-row-right input[type="text"] {
        width: 400px;
        height: 30px;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .profile-image-upload {
        text-align: center;
        position: relative;
        vertical-align: top;
        display: inline-block;
        border-radius: 50%;
        width: 104px;
        height: 104px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(/jnrd/img/profile-image.png);
    }

    .input-row-right {
        font-size: 12px;
        width: 690px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .input-row-left {
        width: 100px;
        text-align: left;
        padding-left: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .f-cb:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmMessageNotification.vue